import { WebCrud } from '../../../containers/crud/webCrud';
import { Crud } from '../../../containers/crud/crud';
import { WebsiteTemplatesForm } from './form';
import { RevalidateWebixCache } from './revalidateWebixCache';

export default function WebsiteTemplate() {
  return (
    <WebCrud api="website-template" FormComponent={WebsiteTemplatesForm}>
      <Crud.Header title="Website Variants">
        <RevalidateWebixCache />
        <Crud.Header.Actions.Add />
        <Crud.Header.Actions.Refresh />
      </Crud.Header>
      <Crud.Table
        actions={[...Crud.Table.RowActions.Common]}
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            width: 100,
          },
          {
            title: 'Slug',
            dataIndex: 'slug',
            width: 120,
          },
          {
            title: 'Repo Link',
            dataIndex: 'repoUrl',
            width: 200,
          },
          {
            title: 'configFileName',
            dataIndex: 'configFileName',
            width: 100,
          },
          {
            title: 'Url',
            dataIndex: 'demoUrl',
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                type: 'text',
                name: 'name',
                inputProps: {
                  placeholder: 'Website Name',
                },
              },
            ]}
          />
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
